import { axios, API } from './config';

export const clientsAPI = {
  getAll: async (search = null) => {
    const params = search ? { search } : {};
    const response = await axios.get(`${API}/clients`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/clients/${id}`);
    return response.data;
  },
  
  create: async (clientData) => {
    const response = await axios.post(`${API}/clients`, clientData);
    return response.data;
  },
  
  update: async (id, clientData) => {
    const response = await axios.put(`${API}/clients/${id}`, clientData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/clients/${id}`);
    return response.data;
  }
};
